export default "__VITE_ASSET__DNGVVAch__"